import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";



export function validateDocumentNumberByType(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const tipoDocIdent = control.get('tipoDocIdent')?.value;
        const numDocIdent = control.get('numDocIdent')?.value;

        if (!tipoDocIdent || !numDocIdent) {
        return null;
        }

        let isValid = false;
        switch (tipoDocIdent) {
        case 'Cédula de Ciudadanía':
            isValid = /^[0-9]{7,10}$/.test(numDocIdent);
            break;
        case 'Pasaporte':
            isValid = /^[A-Za-z0-9]{5,20}$/.test(numDocIdent);
            break;
        case 'Tarjeta de Identidad':
            isValid = /^[0-9]{7,12}$/.test(numDocIdent);
            break;
        case 'Cédula de Extranjería':
            isValid = /^[A-Za-z0-9]{7,15}$/.test(numDocIdent);
            break;
        case 'Permiso por Protección Temporal':
            isValid = /^[0-9]{6,15}$/.test(numDocIdent);
            break;
        }

        return isValid ? null : { invalidDocumentNumber: true };
    };
}
